import { ToolbarGroup } from '@/constants/toolbar';

const gap = 4;
const dividerSize = 1;
const textStyleSizeWidth = 108;
const fontSizeSelectorWidth = 110;

export const ToolbarSizes = {
  gap,
  dividerSize,
  padding: 0,
  btnSize: 34,
  buttonsGap: 4,
  textStyleSizeWidth,
  fontSizeSelectorWidth,
  textStyleWithGap: textStyleSizeWidth + gap + dividerSize,
  fontSizeSelectorWithGap: fontSizeSelectorWidth + gap + dividerSize,
};

export const getVisibleFormattingGroups = (groupsList: ToolbarGroup[], containerWidth: number, sizes = ToolbarSizes) => {
  const { gap, padding, btnSize, buttonsGap, dividerSize, textStyleWithGap, fontSizeSelectorWithGap } = sizes;

  const fixedWidth = padding + textStyleWithGap + fontSizeSelectorWithGap;
  const moreButtonSize = btnSize + gap;

  const data = groupsList.map((item) => ({
    ...item,
    width: item.options.length * (btnSize + buttonsGap) + dividerSize + gap,
  }));

  const totalGroupsWidth = data.reduce((sum, item) => sum + item.width, 0);

  if (fixedWidth + totalGroupsWidth <= containerWidth) {
    return data;
  }

  const visibleGroups = [];
  let totalWidth = fixedWidth + moreButtonSize;

  for (const item of data) {
    if (totalWidth + item.width <= containerWidth) {
      totalWidth += item.width;
      visibleGroups.push(item);
    }
  }

  return visibleGroups;
};
